export const URL = 'https://randomuser.me/api/1.3/?results=62';
export const USER_URL = 'https://randomuser.me/api/1.3/?results=1&nat=us';
